import { render, staticRenderFns } from "./companyDynamics.vue?vue&type=template&id=fd97de04&scoped=true&"
import script from "./companyDynamics.vue?vue&type=script&lang=js&"
export * from "./companyDynamics.vue?vue&type=script&lang=js&"
import style0 from "./companyDynamics.vue?vue&type=style&index=0&id=fd97de04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd97de04",
  null
  
)

export default component.exports